import { jsx as _jsx } from "react/jsx-runtime";
import { Box, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import InterestsTab from '@ui/pages/Settings/components/InterestsTab';
const InterestsTabContent = ({ personId }) => {
    const theme = useTheme();
    const { t } = useTranslation();
    return (_jsx(Box, { sx: {
            backgroundColor: theme.palette.common.whiteTransparent
        }, children: _jsx(InterestsTab, { type: 'people', showFilters: true, showSearch: true, title: t('settings.tags') }) }));
};
export default InterestsTabContent;
